// extracted by mini-css-extract-plugin
module.exports = {"questionMarkIcon":"styles_questionMarkIcon__paxNX","socialLinksSectionContainer":"styles_socialLinksSectionContainer__HYa_y","websiteLink":"styles_websiteLink__O_WwC"};